import React, { useContext } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Avatar,
  Rating,
  Link as MuiLink,
  CardActions,
} from "@mui/material";
import { motion } from "framer-motion";
import { FaQuoteLeft, FaQuoteRight } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom'; 
import ReviewPopup from "./ReviewPopup";
import { AuthContext } from "../auth/AuthContext";
import AddReplyModal from "./forms/AddReplyModal";
import UpdateReviewForm from "./forms/UpdateReviewForm";

// Helper to truncate text
const truncateText = (text, maxLength = 100) => {
  if (!text) return "";
  return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};

export default function ReviewCard({ review, issue = {}, reload, setReload }){
  const location = useLocation()
  const {currentUser} = useContext(AuthContext)

  // Only show reply/update features if URL includes /issues
  const isIssuePage = location.pathname.includes('/issues');
  const isMyReviewsPage = location.pathname.includes('/my-reviews');

  // const isAdmin =
  //   currentUser &&
  //   !!issue &&
  //   (issue?.admin?.user_id === currentUser?.id ||
  //     issue?.solution?.assigned_to?.user_id === currentUser?.id);

  // const canReply = isIssuePage && isAdmin && !review.reply;

   // For reply/update permissions
  const isReviewOwner = currentUser && review?.user?.user_id === currentUser?.id;
  const isAdmin =
    currentUser &&
    !!issue &&
    (issue?.admin?.user_id === currentUser?.id ||
      issue?.solution?.assigned_to?.user_id === currentUser?.id);

  const canReply = isIssuePage && isAdmin && !review.reply;
  const canUpdateReply = isIssuePage && isAdmin && review.reply && review?.reply?.admin?.user_id === currentUser?.id;
  const canUpdateReview = (isIssuePage || isMyReviewsPage) && isReviewOwner;

  
  return (
    <Card
      component={motion.div}
      whileHover={{ scale: 1.05 }}
      transition={{ type: "spring", stiffness: 200 }}
      sx={{
        minWidth: 280,
        maxWidth: 300,
        height: 240,
        mx: 1,
        borderRadius: 3,
        boxShadow: 3,
        backgroundColor: "#d7f5e9", // solid eco-green tint
        border: "1px solid #0a7d40",
        flexShrink: 0,
      }}
    >
      <CardContent sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        {/* User */}
        <Box display="flex" alignItems="center" gap={1.5} mb={1}>
          <Avatar src={review.user.profile} alt={review.user.name} />
          <Box>
            <Typography fontWeight={700}>{review.user.name}</Typography>
            <Typography variant="caption" color="text.secondary">
              {new Date(review.timestamp).toLocaleDateString()}
            </Typography>
            <br/>
            <Typography variant="caption" color="text.secondary" sx={{ mb: 1}}>
                🔗
                <MuiLink
                  component={Link}
                  to={`/issues/${review.issue_id}`}
                  underline="hover"
                  color="primary"
                  sx={{ fontWeight: 300 }}
                >
                  Reported Issue ({review.issue_status || 'Open'})
                </MuiLink>                
              </Typography>
          </Box>
        </Box>

        {/* Rating */}
        <Rating value={review.rating} readOnly size="small" />

        {/* Text */}
        <Typography
          variant="body2"
          mt={1}
          color="text.primary"
          sx={{ flexGrow: 1 , fontFamily:'Lato',fontStyle:'italic'}}
        >
            <FaQuoteLeft style={{ marginRight: 6, color: '#43a047', fontSize: 11 }} />
          {truncateText(review?.review_text)}
          {'  '}
            <FaQuoteRight style={{ marginRight: 6, color: '#43a047', fontSize: 11 }} />
        </Typography>
        
        

        <CardActions display={"flex"} justifyContent="end" alignItems="end" gap={1} mt={1}>

        {/* Reply  */}
          {review?.review_text?.length < 100 && (
            <>
                {canReply && (
                 <AddReplyModal review={review}  reload={reload} setReload={setReload}/> 
                )}
                
                
            
            {canUpdateReview && (
                  <UpdateReviewForm review={review} reload={reload} setReload={setReload} />
                )}
                </>
            )}
          
        {/* Read More */}        
        <ReviewPopup 
        review={review} 
         reload={reload}
          setReload={setReload} 
         issue={issue}
          canUpdateReply={canUpdateReply}
          canUpdateReview={canUpdateReview}
           canReply={canReply}/>
        </CardActions>
        
      </CardContent>
    </Card>
  );
};
